export const bloodTypeFieldOptions = [
  {label: '0(І) Rh+', value: '0 (І) Rh+'},
  {label: '0(І) Rh-', value: '0 (І) Rh-'},
  {label: 'A (II) Rh+', value: 'A (II) Rh+'},
  {label: 'A (II) Rh-', value: 'A (II) Rh-'},
  {label: 'B (III) Rh+', value: 'B (III) Rh+'},
  {label: 'B (III) Rh-', value: 'B (III) Rh-'},
  {label: 'AB (IV) Rh+', value: 'AB (IV) Rh+'},
  {label: 'AB (IV) Rh-', value: 'AB (IV) Rh-'},
]

export const anesthesiaFieldOptions = [
  {
    label: 'в/в',
    value: 'в/в'
  },
  {
    label: 'м/а',
    value: 'м/а',
  },
  {
    label: 'п/а',
    value: 'п/а',
  },
  {
    label: 'ЕТН',
    value: 'ЕТН'
  },
  {
    label: "СМА",
    value: "СМА",
  }
]